import { styled, css, CSSProperties } from 'styled-components';
import React, { PropsWithChildren, ReactNode, useMemo } from 'react';
import OverlayMessage, { OverlayDiv } from './ContentOverlay/OverlayComponents';

const OverlayWrapper = styled.div<{
  $isFlex: boolean;
  $isRow: boolean;
  $isCentered: boolean;
  $minWidth: CSSProperties['minWidth'];
}>`
  ${p =>
    p.$isFlex
      ? css`
          display: flex;
          flex-direction: ${p.$isRow ? 'row' : 'column'};
          min-width: ${p.$minWidth ?? '0'};
        `
      : css`
          display: block;
        `};

  position: relative;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

interface OverlayProps extends PropsWithChildren {
  active?: boolean;
  /** Either a text or custom component to be displayed. If string, it will be wrapped in a <OverlayMessage> */
  overlayContent?: ReactNode;
  contentIsFlex?: boolean;
  contentIsRow?: boolean;
  contentIsCentered?: boolean;
  minWidth?: CSSProperties['minWidth'];
}

export const Overlay: React.FC<OverlayProps> = ({
  children,
  active,
  overlayContent,
  contentIsFlex = true,
  contentIsRow = true,
  contentIsCentered = true,
  minWidth,
}) => {
  const content = useMemo(() => {
    if (typeof overlayContent === 'string') {
      return <OverlayMessage title={overlayContent} />;
    } else {
      return overlayContent;
    }
  }, [overlayContent]);

  return (
    <OverlayWrapper
      data-testid="overlay-wrapper"
      $isFlex={contentIsFlex}
      $isRow={contentIsRow}
      $isCentered={contentIsCentered}
      $minWidth={minWidth}
    >
      {active && <OverlayDiv data-testid="overlay-div">{content}</OverlayDiv>}
      {children}
    </OverlayWrapper>
  );
};
